import { request } from 'shared/api'

type TopTermItem = {
    userId?: string
    gifId: string
    term: string
    rank: number
    impressionCount: number
}

export const getTopTerms = (token, contentType, dateRange, content_id) => {
    const contentTypes = {
        'GIFs & Stickers': 'gif,sticker',
        GIFs: 'gif',
        Stickers: 'sticker',
        Stories: 'story',
    }

    const formatDate = inputDate => {
        let dd = String(inputDate.getDate()).padStart(2, '0')
        let mm = String(inputDate.getMonth() + 1).padStart(2, '0') // January is 0!
        let yyyy = inputDate.getFullYear()
        let string = yyyy + '-' + mm + '-' + dd
        return string
    }

    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const url = `/api/v2/users/top_terms/?start_dt=${startDate}&end_dt=${endDate}&content_type=${contentTypes[contentType]}&gif_ids=${content_id}`
    return request(
        url,
        {
            headers: {},
            credentials: 'omit', // prevent sending cookies in the request (this was overriding the provided token)
        },
        token
    ) as Promise<TopTermItem[]>
}
